import axios from "axios";

import { API_BASE_URL } from "../constants";

export default class DataProtectionTomsService {
  static instance;

  constructor() {}

  static getInstance() {
    if (!DataProtectionTomsService.instance) {
      DataProtectionTomsService.instance = new DataProtectionTomsService();
    }

    return DataProtectionTomsService.instance;
  }

  async list(params = {}) {
    const response = await axios.get(`${API_BASE_URL}/tom`, {
      params: params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });
    return response.data.data;
  }

  async tomDefaults() {
    const response = await axios.get(`${API_BASE_URL}/tom/defaults`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });
    return response.data.data;
  }

  async create(payload) {
    const response = await axios.post(`${API_BASE_URL}/tom/create`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });
    return response.data.data;
  }

  async legalEntitiesWithouTOM(id) {
    const response = await axios.get(
      `${API_BASE_URL}/organization/${id}/legal_entities?only_without_tom=true`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    if (response.data && response?.data?.data) {
      return response?.data?.data;
    } else {
      return [];
    }
  }

  async fetchHeaderInfo(id) {
    const response = await axios.get(`${API_BASE_URL}/tom/${id}/header`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });
    return response.data.data;
  }

  // Change Analyst
  async changeAssignedAnalyst(data, id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/${id}/change_analyst`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );
    return response.data.data;
  }

  // Change Status
  async changeStatus(data, id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/${id}/change_status`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Change Revision
  async changeRevision(data, id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/${id}/change_revision`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Change Entities
  async updateEntities(payload, id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/${id}/change_legal_entities`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // TOM Details
  async fetchDetails(id) {
    const response = await axios.get(`${API_BASE_URL}/tom/${id}/detail`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });
    return response.data.data;
  }

  async fetchExportPDFData(id) {
    const response = await axios.get(`${API_BASE_URL}/tom/${id}/pdf/data`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });
    return response.data.data;
  }

  // TOM Restore
  async restore(id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/${id}/restore`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );
    return response.data.data;
  }

  // Delete subcontractor
  async deleteSubcontractor(id) {
    const response = await axios.delete(
      `${API_BASE_URL}/tom/sub_contractor/${id}/delete`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Create subcontractor
  async createSubcontractor(data, id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/${id}/add_subcontractor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Edit subcontractor
  async editSubcontractor(data, id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/sub_contractor/${id}/edit`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Change Toggle Show PDF
  async changeToggleShowPDF(id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/subsection/${id}/toggle_show_pdf`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Update Information
  async updateInformation(data, id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/subsection/${id}/change_information`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Toggle Measure
  async toggleMeasure(id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/measure/${id}/toggle`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Add measure
  async addMeasure(data) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/subsection/add_measure`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Remove Measure
  async removeMeasure(id) {
    const response = await axios.delete(
      `${API_BASE_URL}/tom/measure/${id}/remove`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );
    return response.data.data;
  }

  // Update Description
  async updateDescription(data, id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/subsection/${id}/change_description`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Tasks
  async fetchTasks(tomId, data = {}) {
    const response = await axios.post(`${API_BASE_URL}/tom/${tomId}/tasks`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });
    return response.data.data;
  }

  // Fetch History Logs
  async fetchLogs(data, id) {
    const response = await axios.get(
      `${API_BASE_URL}/logs?section=tom&tom_id=${id}`,
      {
        params: data,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );
    return response.data.data;
  }

  // Download History Logs
  async fetchLogExport(data, id) {
    const response = await axios.get(
      `${API_BASE_URL}/logs/download?section=tom&tom_id=${id}`,
      {
        params: data,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );
    return response.data.data;
  }

  // Clone
  async cloneTOM(payload = {}, id) {
    const response = await axios.post(
      `${API_BASE_URL}/tom/${id}/duplicate`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  async dashboard() {
    const response = await axios.get(`${API_BASE_URL}/tom/dashboard`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });
    return response.data.data;
  }
}
